import { render } from "./ClientDocument.vue?vue&type=template&id=9ea4914c"
import script from "./ClientDocument.vue?vue&type=script&lang=js"
export * from "./ClientDocument.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__